export enum MessageStatusesEnum {
  DELETED = "DELETED",
  SENT = "SENT",
  UPDATED = "UPDATED",
}
